// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Browser from "meros/browser";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

let isAsyncIterable = (function isAsyncIterable(input) {
	return (
		typeof input === 'object' &&
		input !== null &&
		(input[Symbol.toStringTag] === 'AsyncGenerator' ||
			Symbol.asyncIterator in input)
	)
});

let decodeEachChunk = (async function(parts, onNext, onError) {
    for await (const part of parts) {
			if (!part.json) {
        // console.log("no json from part", part);
				// onError(new Error('Failed to parse part as json.'));
				break;
			}

			onNext(part.body);
    }
  });

function getChunks(response, onNext, onError, onComplete) {
  return Browser.meros(response).then(parts => {
    if (isAsyncIterable(parts)) {
      return decodeEachChunk(parts, onNext, onError).then(() => {
        onComplete();
        return Promise.resolve();
      });
    }
    try {
      return parts.json().then(json => {
        onNext(json);
        onComplete();
        return Promise.resolve();
      });
    } catch (raw_err) {
      let err = Primitive_exceptions.internalToException(raw_err);
      if (err.RE_EXN_ID === "JsExn") {
        onError(err._1);
        return Promise.resolve();
      }
      throw err;
    }
  });
}

export {
  getChunks,
}
/* decodeEachChunk Not a pure module */
